import 'bootstrap/dist/css/bootstrap.min.css'
import { useEffect, useState, useRef } from 'react'
import axios from 'axios'

function CercaArtista({ flag, dettagliIsOpen, dati }) {

    const [formData, setFormData] = useState('')
    const [artisti, setArtisti] = useState({})
    const [msg, setMsg] = useState({ msg1: null, msg2: null })//per controllo campo obbligatorio in tipologia from input
    const [cityFilter, setCityFilter] = useState([])//città/regione filtrate ad ogni change dell'input 'città'
    const [città, setCittà] = useState([])
    const [generiFilter, setGeneriFilter] = useState([])//genere/nome filtrati ad ogni change dell'inputù
    const [artistiTrovati, setArtistiTrovati] = useState([])
    const [scelta, setScelta] = useState("")

    const cittàValue = useRef()
    const cercaPerCittàDiv = useRef()// div del cerca artista per città o regione

    function handleChangeCittà(e) {//CREAZIONE BANNER RICERCA PER CITTA'
        const { value } = e.target
        let filter = []
        if (value) {
            artisti.forEach(elem => {
                if (elem?.regione?.toLowerCase().includes(value.toLowerCase())) {
                    filter.push(elem.regione)
                }
                if (elem?.città?.toLowerCase().includes(value.toLowerCase())) {
                    filter.push(elem.città)
                }
            })
        }
        if (filter.length > 0) {
            filter = filter.filter((value, index) => filter.indexOf(value) === index)//tolgo le città ripetute
            console.log(filter)
        }
        setCityFilter(filter.length > 0 ? filter.filter(item => item !== null || item !== '') : [])
        setMsg(x => ({ ...x, msg2: filter.length === 0 && value ? '*** Nessuna elemento trovato ***' : '' }))
    }
    const cittàCliccata = async (elem) => {//QUANDO CLICCO DA BANNER CITTA' TROVATE
        cittàValue.current.value = elem
        setFormData({ ...formData, città: elem })

        const artistaByGenere = artisti.filter(item =>
            (item.città.toUpperCase() === elem.toUpperCase() || item.regione.toUpperCase() === elem.toUpperCase()) && (item.accettazione === 'true'))
        if (artistaByGenere.length === 0) {
            return
        }
        setArtistiTrovati(artistaByGenere)
        dettagliIsOpen('flag1')
    }
    function handleChangeGenere(e) {//CREAZIONE BANNER GENERE/NOMI
        const { value } = e.target
        let filter = []
        if (value.toLowerCase() !== '') {
            città.some((elem, index) => {//filtraggio generi/nomi da input               
                if (elem?.toLowerCase().includes(value.toLowerCase())) {
                    filter.push(elem)
                }
            }); console.log('filter:', filter.length)
        }
        if (filter.length > 0) {//se dall'input viene trovata una corrisdpondenza
            filter = filter.filter((value, index) => filter.indexOf(value) === index)//tolgo gli elementi ripetuti 
        }
        setGeneriFilter(filter)
        setMsg(x => ({ ...x, msg1: filter.length === 0 && value ? '*** Nessuna elemento trovato ***' : '' }))
    }
    const genereCliccato = (elem) => {//QUANDO CLICCO UN ELEM DA BANNER GENERE/NOME
        const artistaByGenere = artisti.filter(item =>
            (item.genere?.toUpperCase() === elem.toUpperCase() || item.gruppo?.toUpperCase() === elem.toUpperCase() || item.soggetto?.toUpperCase() === elem.toUpperCase() || item.nome?.toUpperCase() === elem.toUpperCase() || item.cognome?.toUpperCase() === elem.toUpperCase()) && (item.accettazione === 'true'))
        if (artistaByGenere.length === 0) {
            return
        }
        setArtistiTrovati(artistaByGenere)
        dettagliIsOpen('flag1')
    }
    function handleChangeSelect(e) {//cerca dal select (tipicizzata)
        setGeneriFilter([]); setCityFilter([])
        const { value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        setScelta(inputValue)
        getArtisti(inputValue, 'msgTipologiaPredef')
    }
    function getArtisti(inputValue, msgTipologia) {//cerca artista da select
        const artistaByGenere = artisti.filter(x => x.genere === inputValue)
        if (artistaByGenere.length > 0) {//artista trovato da select: apro il banner 'flag1'
            setArtistiTrovati(artistaByGenere)
            dettagliIsOpen('flag1')
        }
        setMsg({ msg0: artistaByGenere.length === 0 ? '*** Nessun artista trovato ***' : null })
    }
    useEffect(() => {//caricamento Città Regione da server nodejs (MYSQL)
        let arr = []
        axios.post('/getArtisti/DESC/id').then(res => {
            setArtisti(res.data.filter(item => item.sezione === "artista"))
            const response = res.data
            response.forEach(element => {//carico 'setCittà' con le città presenti in MYSQL
                if (element.sezione === 'artista')
                    arr.push(element.genere, element.gruppo, element.soggetto, element.nome, element.cognome)
            })
            setCittà(arr.filter(item => item !== null || item !== ''))
        })
    }, [])
    // useEffect(() => { console.log("cityFilter:", cityFilter) }, [cityFilter])

    return (<>
        <div className='container' style={{ backgroundColor: 'whitesmoke', marginTop: '3rem' }}>
            <hr />
            <div style={{ margin: '2rem 0' }}>
                <h3 style={{ textAlign: 'center' }}>TROVA ARTISTA</h3>
                {/* ---------------------- CERCA PER TIPOLOGIA PREDEFINITA -------------------- */}
                <div className="input-group mb-3">
                    <div className='cercaArtistiDiv' style={{ border: '1px solid grey' }}>
                        <img src="https://img.icons8.com/?size=100&id=59878&format=png&color=000000" className='cercaArtisti' alt='' />
                    </div>
                    <select style={{ display: 'inline', marginRight: '5%', border: '1px solid grey', padding: '5px', width: '85%' }}
                        name="tipologia" onChange={handleChangeSelect} value={scelta}>
                        <option value="" disabled>Seleziona un artista</option>
                        <option value="Acrobata">Acrobata</option>
                        <option value="Animatore">Animatore</option>
                        <option value="Arte del palloncino">Arte del palloncino</option>
                        <option value="Artista di strada">Artista di strada</option>
                        <option value="Artista del fuoco">Artista del fuoco</option>
                        <option value="Band per tributi">Band per tributi</option>
                        <option value="Band musica live">Band musica live</option>
                        <option value="Bolle di sapone">Bolle di sapone</option>
                        <option value="Cabarettista">Cabarettista</option>
                        <option value="Cantante">Cantante</option>
                        <option value="Cartomante">Cartomante</option>
                        <option value="Circense">Circense</option>
                        <option value="Clown">Clown</option>
                        <option value="DJ">DJ set</option>
                        <option value="DJ">DJ set</option>
                        <option value="Drag queen">Drag queen</option>
                        <option value="Imitatore">Imitatore</option>
                        <option value="Mago">Mago</option>
                        <option value="Mimo">Mimo</option>
                        <option value="Musicista">Musicista</option>
                        <option value="Orchestra">Orchestra</option>
                        <option value="Ritrattista">Ritrattista</option>
                        <option value="Sand artist">Sand artist</option>
                        <option value="Scuola di ballo">Scuola di ballo</option>
                        <option value="Spettacolo per bambini">Spettacolo per bambini</option>
                        <option value="Spettacolo pirotecnico">Spettacolo pirotecnico</option>
                        <option value="Statua vivente">Statua vivente</option>
                        <option value="Street artist">Street artist</option>
                        <option value="Teatro burattini">Teatro burattini</option>
                        <option value="Teatro dialettale">Teatro dialettale</option>
                        <option value="Trampoliere">Trampoliere</option>
                        <option value="Truccabimbi">Truccabimbi</option>
                    </select>
                </div>
                {msg.msg0 && <p style={{ color: 'red' }}><i>{msg.msg0}</i></p>}

                {/* ---------------- CERCA PER INPUT DELL'UTENTE ------------------- */}
                <div className="input-group mb-3">
                    <div className='cercaArtistiDiv' style={{ border: '1px solid grey' }}>
                        <img src="https://img.icons8.com/?size=100&id=59878&format=png&color=000000" className='cercaArtisti' alt='' />
                    </div>
                    <input id='genere' style={{ display: 'inline', border: '1px solid grey', width: ' 85%', padding: '5px' }}
                        type='text'
                        placeholder='es. genere, nome o gruppo'
                        onChange={handleChangeGenere}
                        maxLength={45} />
                    <button style={{ float: 'right', fontSize: '18px', marginLeft: '-25px' }} onClick={() => {
                        setGeneriFilter([]); document.getElementById('genere').value = ''; setMsg({ msg1: null })
                    }}>X
                    </button>
                    <div>
                        {msg.msg1 && <p style={{ color: 'red' }}><i>{msg.msg1}</i></p>}
                    </div>
                </div>
                {/* ----------------- BANNER ARTISTI DA INPUT ---------------------------------------------------------------------------------- */}
                {generiFilter.length !== 0 &&
                    <div style={{
                        border: '1px solid black', zIndex: '1', padding: '5px', position: 'absolute', left: '6%', top: '310px', width: '14rem', backgroundColor: 'whitesmoke'
                    }}>
                        <img src={require('../image/icons8-chiudi-macos-32.png')} alt='' style={{ cursor: 'pointer', float: 'right' }} onClick={
                            () => { setGeneriFilter([]) }
                        } /><br />
                        {generiFilter.length !== 0 &&
                            generiFilter.map((elem, index) => (
                                <span className='filterCity ' key={index}>
                                    <p style={{ cursor: 'pointer', fontSize: 'medium', margin: '-6px 0 -3px 0' }} onClick={() => { genereCliccato(elem) }}>
                                        {elem.toUpperCase()}
                                    </p>
                                    {generiFilter.length !== index + 1 && <hr />}
                                </span>
                            ))}
                    </div>
                }

                {/* ---------------- CERCA CON CHIAVE CITTA'/REGIONE ------------------- */}
                <div className='text-center'>
                    <button className='btn btn-success' type='button' onClick={() => {
                        if (cercaPerCittàDiv.current.style.display === 'block') {
                            cercaPerCittàDiv.current.style.display = 'none'
                        }
                        else { cercaPerCittàDiv.current.style.display = 'block' }
                    }}>CERCA PER REGIONE O CITTA'
                    </button>
                </div>
                <div ref={cercaPerCittàDiv} style={{ display: 'none' }}>
                    <div className="input-group mb-1 mt-2">
                        <div className='cercaArtistiDiv' style={{ border: '1px solid grey' }}>
                            <img src="https://img.icons8.com/?size=100&id=59878&format=png&color=000000" className='cercaArtisti' alt='' />
                        </div>
                        <input id='city' style={{ display: 'inline', border: '1px solid grey', width: '85%', padding: '5px' }}
                            type='text'
                            name='città'
                            placeholder='Es. Lazio'
                            onChange={handleChangeCittà}
                            ref={cittàValue}
                        />
                        <button style={{ float: 'right', fontSize: '18px', marginLeft: '-25px' }} onClick={() => {
                            setCityFilter([]); document.getElementById('city').value = ''; setMsg({ msg2: null })
                        }}>X
                        </button>
                    </div>
                    <div>
                        {msg.msg2 && <p style={{ color: 'red' }}>{msg.msg2}</p>}
                    </div>
                </div>

                {/* ----------------- BANNER CITTA' TROVATE -------------------- */}
                {cityFilter.length !== 0 &&
                    <div style={{
                        border: '1px solid black', zIndex: '1', padding: '5px', position: 'absolute', left: '6%', width: '14rem', backgroundColor: 'whitesmoke'
                    }}>
                        <img src={require('../image/icons8-chiudi-macos-32.png')} alt='' style={{ cursor: 'pointer', float: 'right' }} onClick={
                            () => { setCityFilter([]) }
                        } /><br />
                        {cityFilter &&
                            cityFilter.map((elem, index) => (
                                <span className='filterCity' key={index}>
                                    <p style={{ cursor: 'pointer', fontSize: 'medium', margin: '-6px 0 -3px 0' }} onClick={() => { cittàCliccata(elem) }}>{elem}
                                    </p>
                                    {cityFilter.length !== index + 1 && <hr />}
                                </span>
                            ))}
                    </div>
                }
            </div>
            <hr />
        </div>


        {/* --------------------- BANNER ARTISTI DOPO LA RICERCA ------------------------------------------------------------------------------------------- */}
        <div className='visualDettagli' style={{ top: `${flag === 'flag1' || flag === 'artistaDetails' ? '0' : '120%'}` }}>
            {artistiTrovati.length !== 0 &&
                <div style={{ padding: '5px 0' }}>
                    <span onClick={() => { window.history.back() }}
                        style={{ marginRight: '1.5em', fontSize: 'xx-large', cursor: 'pointer' }}>◁
                    </span>
                    <h3 style={{ display: 'inline', fontWeight: '600', fontFamily: 'sans-serif', textAlign: 'center' }}>
                        Artisti/Band
                    </h3>
                </div>
            }
            <hr />
            <div className='bodyPadding' style={{ overflowY: 'scroll', height: '78%', scrollBehavior: 'smooth' }}>
                {artistiTrovati &&
                    artistiTrovati.reverse().filter(item => (item.accettazione === 'true'))
                        .map(elem => {
                            let arrImg
                            if (elem.img) arrImg = elem.img.split(',')
                            return (
                                <div key={elem.id}>
                                    {elem.img &&
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${arrImg[0]}`}
                                            style={{ width: '70px', height: '70px', objectFit: 'cover', borderRadius: '50%' }} alt='' />
                                    }
                                    {/* ----------- GRUPPO Nome Cognome -------------------- */}
                                    <p className='fw-semibold fs-4 mt-2'>{elem?.gruppo?.toUpperCase()} <i className='fs-6'>{elem.nome} {elem.cognome}</i>
                                    </p>
                                    {/* ----------------- GENERE + CITTA' ---------------------------- */}
                                    <p className='fs-5 text-success'>{elem.genere} {elem.città && <span className='text-dark fs-6 fw-normal'>({elem.città})</span>}
                                    </p>
                                    {/* ----------------- SOGGETTO ---------------------------- */}
                                    {elem.soggetto && <p style={{ fontSize: '14px', marginTop: '-13px' }}>{elem.soggetto}</p>}
                                    {/* ------------------  TELEFONO + EMAIL ------------------- */}
                                    {elem.telefono &&
                                        <p className='mt-2' style={{ display: 'grid', gridTemplateColumns: '0.1fr 1fr', gap: '0' }}>
                                            <p><img src={require('../image/icons8-telefono-cellulare-48.png')} width='25em' alt='' /></p><p>{elem.telefono}</p>
                                            <p><img src={require('../image/icons8-nuovo-messaggio-48.png')} width='25em' alt='' /></p><p>{elem.emailUser}</p>
                                        </p>
                                    }
                                    <button className='btn btn-primary' style={{ fontSize: 'small', fontWeight: '600' }} onClick={() => {
                                        dati(elem); dettagliIsOpen('artistaDetails')
                                    }}>Dettagli
                                    </button>
                                    <hr style={{ height: '2px', backgroundColor: 'black' }} />
                                </div>
                            )
                        })
                }
            </div>
        </div>
    </>)
}
export default CercaArtista